'use client'

import { CustomDataFieldOverflowMenu } from '@repo/custom-data-pages/CustomDataFieldOverflowMenu'
import { useCustomDataPageStore } from '@repo/store/useCustomDataPageStore'
import { useState, useEffect } from 'react'
import MUITypography from '@mui/material/Typography'
import MUISkeleton from '@mui/material/Skeleton'
import PropTypes from 'prop-types'

export const CustomDataFieldReadState = ({ value, field, setShowInlineEdit, valuesLoaded }) => {
  const { getRenderedValueOfCustomDataField } = useCustomDataPageStore()
  const [renderedValue, setRenderedValue] = useState('')
  const { fieldType } = field || {}

  useEffect(() => {
    if (renderedValue && renderedValue !== '-') return

    const getValueToRender = async () => {
      const renderValue = await getRenderedValueOfCustomDataField({ fieldType, value })
      setRenderedValue(renderValue)
    }

    getValueToRender()
  }, [fieldType, value, renderedValue, getRenderedValueOfCustomDataField, valuesLoaded])

  return (
    <>
      {valuesLoaded ? (
        <CustomDataFieldOverflowMenu setShowInlineEdit={setShowInlineEdit} field={field} value={renderedValue} />
      ) : null}
      <MUITypography
        variant="body1"
        data-testid="CustomDataFieldReadState"
        sx={{ cursor: 'pointer', display: 'inline-block', whiteSpace: 'pre-line' }}
      >
        {valuesLoaded ? (
          renderedValue
        ) : (
          <MUISkeleton
            variant="text"
            width={`${Math.random() * 200}px`}
            height="20px"
            sx={{ transition: 'width 250ms' }}
          />
        )}
      </MUITypography>
    </>
  )
}

CustomDataFieldReadState.propTypes = {
  value: PropTypes.any,
  field: PropTypes.object,
  setShowInlineEdit: PropTypes.func,
  valuesLoaded: PropTypes.bool
}
